import React from 'react';
import type { CustomInnerHeaderProps } from 'ag-grid-react';

export interface MyCustomInnerHeaderProps extends CustomInnerHeaderProps {
  icon?: string; 
  headerElement?: JSX.Element;
}

const HeaderIcon: React.FC<MyCustomInnerHeaderProps> = (props) => {
  const iconClass = props?.icon ?? '';
  const headerElement = props?.headerElement ?? undefined;
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'visible', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
    { headerElement ?  headerElement :  
    <div
        style={{
          backgroundColor: '#ffffff',
          border: '1px solid #ccc',
          position: 'absolute',
          left: '50%',
          top: '40%',
          transform: 'translateX(-55%)',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10,
        }}
        title="Actions"
      >
        { iconClass ? <i className={iconClass} /> : undefined }
      </div>
    }
    </div>
  );
};

export default HeaderIcon;
